module.exports = __webpack_public_path__ + "static/15.1_romes_decline_and_legacy-43acf0b53bde7e438997c57ee8a19b0e.pdf";